export const DISTRIBUIDOR = 'Distribuidor';
export const FABRICANTE = 'Fabricante';
export const IMPORTADOR = 'Importador';
export const UJ = 'UJ';
